var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{staticClass:"no-print"}),_c('main',{staticClass:"container"},[_c('router-view')],1),_c('Footer'),_c('button',{staticClass:"gototop",on:{"click":_vm.gototop}},[_c('i',{staticClass:"fas fa-angle-up"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }